// 空状态生成器：住宿卡（lodging）
export function createEmptyLodgingPayload() {
  return {
    // Hint downstream editors and uploaders about the intended card type
    card_type: 'lodging',
    type: 'lodging',
    title: '请输入酒店名称',
    imageUrl: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=1200&h=600&fit=crop&auto=format',
    address: '请填写酒店地址',
    description: '这里请填写酒店的描述',
    metaPairs: [],
    tags: [],
    card: {},
  };
}
